import { render, staticRenderFns } from "./mecard.vue?vue&type=template&id=10e949a8&scoped=true&"
import script from "./mecard.vue?vue&type=script&lang=js&"
export * from "./mecard.vue?vue&type=script&lang=js&"
import style0 from "./mecard.vue?vue&type=style&index=0&id=10e949a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e949a8",
  null
  
)

export default component.exports